import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'baseline',
  },
  name: {
    color: '#F1F5F9',
    fontWeight: 700,
    fontSize: '0.95rem',
    letterSpacing: '0.01em',
    whiteSpace: 'nowrap',
  },
  dot: {
    color: '#0EA5E9',
  },
});

const LogoFull = () => {
  const classes = useStyles();
  return (
    <span className={classes.root}>
      <span className={classes.name}>
        Eduardo Tourinho<span className={classes.dot}>.</span>
      </span>
    </span>
  );
};

export default LogoFull;
